import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { ProdProcessType } from "../models/prod-process-type";

@Injectable({ providedIn: 'root'})
export class ProdProcessTypeService{
    constructor(private _http: HttpClient){}


    getAll(){
        return this._http.get<ProdProcessType[]>(`${environment.rydApiUrl}/api/prod-process-type`);
    }
}
